import React, { useState } from "react";
import SecondaryHeader from "../../components/common/SecondaryHeader";
import { FaRegEnvelopeOpen } from "react-icons/fa6";
import { FiPhoneOutgoing } from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";
import { CircleArrowDown } from "lucide-react";
const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
  };

  return (
    <React.Fragment>
      <SecondaryHeader
        pageHeading="Contact Us"
        breadcomb={<span>Home / Contact</span>}
      />

      <div className="grid gap-2 sm:gap-3 md:gap-4 lg:gap-7 md:pt-20 pt-10 sm:grid-cols-3 px-6 xl:px-20 lg:grid-cols-3 items-stretch">
        <div className="bg-white rounded-3xl shadow-lg px-5 py-5 lg:px-10 lg:py-10 space-y-2 flex flex-col justify-between gap-5">
          <div className="space-y-2 flex gap-3">
            <FaRegEnvelopeOpen size={20} className="mt-3" />
            <div>
              <p className="font-bold text-lg">Support email</p>
              <p className="text-gray-500">sekharbuilders@gmail.com</p>
            </div>
          </div>
          <div className="flex items-center justify-center">
            {" "}
            <a
              href="mailto:sekharbuilders@gmail.com"
              className="w-[80%] text-center rounded-full px-3 py-2 md:py-3  bg-[rgb(228,237,100)] transition-colors duration-300  md:px-2 bg- hover:bg-black hover:text-white"
            >
              <span className="font-medium">Email Us</span>
            </a>
          </div>
        </div>
        <div className="bg-white rounded-3xl shadow-lg px-5 py-5 lg:px-10 lg:py-10 space-y-2 flex flex-col justify-between gap-5">
          <div className="space-y-2 flex gap-2">
            <FiPhoneOutgoing size={20} className="mt-3" />
            <div>
              <p className="font-bold text-lg">Phone number</p>
              <p className="text-gray-500">+91 9437062040</p>
              <p className="text-gray-500">+91 9438299105</p>
            </div>
          </div>
          <div className="flex items-center justify-center">
            {" "}
            <a
              href="tel:+91 9437062040"
              className="w-[80%] rounded-full px-3 py-2 md:py-3  bg-[rgb(228,237,100)] transition-colors duration-300  md:px-2 text-center hover:bg-black hover:text-white"
            >
              <span className="font-medium">Call Us</span>
            </a>
          </div>
        </div>
        <div className="bg-white rounded-3xl shadow-lg px-5 py-5 lg:px-10 lg:py-10 space-y-2 flex flex-col justify-between gap-5">
          <div className="space-y-2 flex justify-center items-start gap-3">
            <IoLocationOutline size={20} className="mt-3" />
            <div>
              <p className="font-bold text-lg">Location</p>
              <li className="text-gray-500 tracking-tighter ">
                N/6 - 274, IRC Village, Jayadev Vihar, Bhubaneswar, Odisha-751
                015
              </li>
              <p className="text-black text-base flex gap-2">
                {" "}
                Banch Office{" "}
                <span>
                  <CircleArrowDown size={18} className="mt-1" />
                </span>
              </p>
              <li className="text-gray-500 tracking-tighter ">
                N/4 - 57, IRC Village, Nayapalli, Bhubaneswar, Odisha-751 015
              </li>
            </div>
          </div>
          <div className="flex items-center justify-center">
            {" "}
            <a
              href="https://maps.app.goo.gl/h8mJ5qZRGB2eNmXv5"
              target="_blank"
              rel="noopener noreferrer"
              className="w-[80%] rounded-full px-3 py-2 md:py-3 text-center bg-[rgb(228,237,100)] transition-colors duration-300  md:px-2 bg- hover:bg-black hover:text-white"
            >
              <span className="font-medium">Visit Us</span>
            </a>
          </div>
        </div>
      </div>

      {/* Map & Contact Form Section */}
      <section className="py-16">
        <div className="max-w-[89rem] 2xl:max-w-[84rem] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Equal height columns */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
            {/* Map Section */}
            <div className="space-y-6 h-full">
              <div className="bg-white rounded-2xl shadow-lg p-6 h-full flex flex-col">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  Our Location
                </h3>
                <p className="text-gray-600 mb-6">
                  Visit our office or get in touch with us through any of the
                  available channels.
                </p>

                {/* Map fills remaining height */}
                <div className="rounded-xl h-[50vh] lg:h-full overflow-hidden shadow-md flex-grow">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11674.592733047983!2d85.80768977480244!3d20.29585766446449!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909c5a465032d%3A0xa086a020ad493d75!2sSekhar%20Builders%20And%20Ptomoters%20Pvt.%20Ltd.!5e1!3m2!1sen!2sin!4v1762594529214!5m2!1sen!2sin"
                    className="w-full h-full border-0"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Our Office Location"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="bg-white rounded-2xl shadow-lg p-6 lg:p-8 h-full flex flex-col">
              <div className="mb-8">
                <h2 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-3">
                  Get In Touch
                </h2>
                <p className="text-gray-600 text-lg">
                  We'd love to hear from you if you have any questions
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
                className="space-y-6 flex-grow flex flex-col justify-between"
              >
                {/* Row 1: Name fields */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
                  <div className="space-y-2">
                    <label
                      htmlFor="firstName"
                      className="block font-semibold text-gray-700 text-sm lg:text-base"
                    >
                      First Name *
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      placeholder="First Name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-sm lg:text-base"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label
                      htmlFor="lastName"
                      className="block font-semibold text-gray-700 text-sm lg:text-base"
                    >
                      Last Name *
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      placeholder="Last Name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-sm lg:text-base"
                      required
                    />
                  </div>
                </div>

                {/* Row 2: Email & Phone */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
                  <div className="space-y-2">
                    <label
                      htmlFor="email"
                      className="block font-semibold text-gray-700 text-sm lg:text-base"
                    >
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="your.email@example.com"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-sm lg:text-base"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label
                      htmlFor="phone"
                      className="block font-semibold text-gray-700 text-sm lg:text-base"
                    >
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+1 (555) 123-4567"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-sm lg:text-base"
                    />
                  </div>
                </div>

                {/* Message */}
                <div className="space-y-2">
                  <label
                    htmlFor="message"
                    className="block font-semibold text-gray-700 text-sm lg:text-base"
                  >
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Tell us about your inquiry..."
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 resize-vertical text-sm lg:text-base"
                    required
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-black hover:bg-[#e4e95b] hover:text-black text-white font-semibold py-4 px-6 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black text-base lg:text-lg"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 md:mb-6 mb-4">
            We're Here to Help
          </h2>
          <p className="sm:text-xl text-base text-gray-600 max-w-3xl mx-auto md:mb-8 mb-6">
            Our team is available Monday to Friday from 9:00 AM to 6:00 PM. We
            typically respond to all inquiries within 24 hours.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiPhoneOutgoing size={24} className="text-blue-600" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Quick Response</h3>
              <p className="text-gray-600">
                Get answers to your questions within hours
              </p>
            </div>
            <div className="text-center">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaRegEnvelopeOpen size={24} className="text-green-600" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Email Support</h3>
              <p className="text-gray-600">
                Detailed support via email for complex issues
              </p>
            </div>
            <div className="text-center">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <IoLocationOutline size={24} className="text-purple-600" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Office Visit</h3>
              <p className="text-gray-600">
                Schedule an in-person meeting with our team
              </p>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
export default Contact;
